export default __webpack_public_path__ + "static/media/alford.8343773f.png";